export const REPORT_COLUMNS = [
    { key: 'nome', label: 'Nome', width: 260, align: 'left' },
    { key: 'total', label: 'Total', width: 115, format: 'number' },
    { key: 'loja', label: 'Loja', width: 115, format: 'number' },
    { key: 'agenda', label: 'Agenda', width: 115, format: 'number' },
    { key: 'codigo', label: 'Código', width: 115, format: 'number' },
    { key: 'mala', label: 'Mala', width: 115, format: 'number' },
    {
        key: 'sssg',
        label: 'SSSG',
        width: 115,
        format: 'percent',
        clickable: true,
    },
    { key: 'off', label: 'Off', width: 115, format: 'percent' },
    { key: 'on', label: 'On', width: 115, format: 'percent' },
    { key: 'projPercent', label: 'Proj. %', width: 115, format: 'percent' },
    { key: 'projValue', label: 'Proj. R$', width: 115, format: 'number' },
    { key: 'lastYear', label: 'Last year', width: 115, format: 'number' },
    { key: 'cota', label: 'Cota', width: 115, format: 'number' },
];

export const STORE_REPORT_COLUMNS = REPORT_COLUMNS.map(column =>
    column.key === 'nome' ? { ...column, label: '' } : column
);

export const VENDEDORES_REPORT_COLUMNS = REPORT_COLUMNS.map(column => {
    if (column.key === 'projPercent') {
        return { ...column, label: 'Proj. em %' };
    }
    if (column.key === 'projValue') {
        return { ...column, label: 'Proj. em R$' };
    }
    return column;
});

export function formatReportValue(value, format) {
    if (value === null || value === undefined) {
        return '-';
    }
    if (format === 'percent') {
        return `${(value * 100).toFixed(2).replace('.', ',')}%`;
    }
    if (format === 'number') {
        return new Intl.NumberFormat('pt-BR').format(value);
    }
    return value;
}

export function mapApiFieldsToRow(id, nome, fields, isTotal = false) {
    const total = fields?.total ?? null;
    const loja = fields?.store ?? null;
    const agenda = fields?.crm_agenda ?? null;
    const codigo = fields?.code ?? null;
    const mala = fields?.bag ?? null;
    const sssg = fields?.sssg ?? null;
    const off = fields?.off ?? null;
    const on = fields?.on ?? null;
    const projPercent = fields?.proj_perc ?? null;
    const projValue = fields?.proj_real ?? null;
    const lastYear = fields?.last_year ?? null;
    const cota = fields?.target ?? null;

    return {
        id,
        nome,
        isTotal,
        total,
        loja,
        agenda,
        codigo,
        mala,
        sssg,
        off,
        on,
        projPercent,
        projValue,
        lastYear,
        cota,
        sssgDetails: {
            sssgGeral: { sssg, projecao: projPercent },
            sssgOnOff: { on, off },
            valoresAnoPassado: {
                totalLastYear: lastYear,
                vendaOn: null,
                vendaOff: null,
            },
            valoresEsperados: {
                esperadoOn: null,
                esperadoOff: null,
            },
            outrosValores: { loja, agenda, codigo, mala },
        },
    };
}
